import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { AppelsService } from 'src/app/modules/appels/service/appels.service';

@Component({
  selector: 'app-side-bar-gestionnaire-benin',
  templateUrl: './side-bar-gestionnaire-benin.component.html',
  styleUrls: ['./side-bar-gestionnaire-benin.component.css'],
  animations: [
    trigger('slideToggle', [
      state('open', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      state('closed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      transition('open <=> closed', [animate('300ms ease-in-out')]),
    ]),
  ],
  encapsulation: ViewEncapsulation.None,
})
export class SideBarGestionnaireBeninComponent {
  urlFormationMoodle = 'https://formation.force-n.sn/my/';
  user: any | null;
  profil: any;
  logged: any;
  role!: any;
  isBeninGestionnaire!: any;
  cohorte!: string;
  nomrole!: string;
  isFcc: boolean = false;
  isCom: boolean = false;
  isBoard: boolean = false;
  isSEV: boolean = false;
  isStemd: boolean = false;
  isFinance: boolean = false;
  isAipen: boolean = false;
  urlFondAmorcage: string = 'https://fa.force-n.sn/auth/login/keycloak';

  sections = [
    { id: 1, isCollapsed: true },
    { id: 2, isCollapsed: true },
    { id: 3, isCollapsed: true },
    { id: 4, isCollapsed: true },
  ];
  listofftrack: any;
  iuf: any;
  showIframe = false;
  constructor(
    private router: Router,
    private appelservice: AppelsService,
  ) { }
  ngOnInit() {
    this.user = sessionStorage.getItem('user');
    this.iuf = JSON.parse(this.user).iuf;
    this.getOfftrack();
    this.logged = sessionStorage.getItem('logged');
    this.profil = JSON.parse(this.user).profile.id;

    this.role = JSON.parse(this.user)?.roles;
    this.cohorte = JSON.parse(
      this.user,
    ).beneficiaryCohortes[0]?.cohorte.cohorteName;
    if (this.role.length > 0) {
      this.role.forEach((element: { id: number; roleName: any }) => {
        this.nomrole = element.roleName;
        sessionStorage.setItem('nomrole', this.nomrole);
        switch (element.roleName) {
          case 'gestionnaire': {
            this.isFcc = true; // Gestionnaire FCC
            break;
          }
          case 'suivi': {
            this.isSEV = true; // Gestionnaire Suivi Evaluation
            break;
          }
          case 'finance': {
            this.isFinance = true; //Gestionnaire Finance
            break;
          }
          case 'aipen': {
            this.isAipen = true; //Gestionnaire AIPEN
            break;
          }

          case 'stemd': {
            this.isStemd = true; //Gestionnaire Stemd
            break;
          }

          case 'com': {
            this.isCom = true; //Gestionnaire Com
            break;
          }

          case 'board': {
            this.isBoard = true; // Programme Board
            break;
          }

          case 'gestionnaire-fcc-benin': {
            this.isBeninGestionnaire = true;
            break;
          }
        }
      });
    }
    // console.log('user role: ', this.user);
  }

  reloadComponent(self: boolean, urlToNavigateTo?: string) {
    const url = self ? this.router.url : urlToNavigateTo;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`/${url}`]).then(() => { });
    });
  }

  sessionChange(cohorte: string) {
    sessionStorage.setItem('cohorte', cohorte);
    this.router.navigate(['dashboard/appels/candidatures/' + cohorte]);
    setTimeout(() => {
      this.reloadComponent(false, 'dashboard/appels/candidatures/' + cohorte);
    }, 500);
  }

  sessionChangeHparcours(cohorte: string) {
    sessionStorage.setItem('cohorte', cohorte);
    this.router.navigate(['dashboard/appels/candidaturesHS/' + cohorte]);
    setTimeout(() => {
      this.reloadComponent(false, 'dashboard/appels/candidaturesHS/' + cohorte);
    }, 500);
  }

  toggleCollapse(id: number): void {
    const section = this.sections.find((sec) => sec.id === id);
    if (section) {
      section.isCollapsed = !section.isCollapsed;
    }
  }

  openUrl(url: string) {
    window.open(url, '_blank');
  }
  getOfftrack() {
    this.appelservice.getOffTractBeninWithCohortes(this.iuf).subscribe({
      next: (data: any[]) => {
        // console.log(data);
        this.listofftrack = data.map((family) => ({
          ...family,
          isCollapsed: true,
        }));
      },
      error: (error) => {
        console.error(error);
        alert("Une erreur s'est produite lors de la récupération des données");
      },
    });
  }
  toggleOfftrack(offtrack: any) {
    offtrack.isCollapsed = !offtrack.isCollapsed;
  }
}
